import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";

const Box = styled(motion.li)`
  width: 23.5rem;
  height: 55vh;
  background-color: #ffffff;
  color: #000;
  padding: 1rem 2rem;
  margin-right: 2rem;
  border-radius: 0 50px 0 50px;
  display: flex;
  flex-direction: column;

  border: 1px solid #fff;
  transition: all 0.2s ease;

  &:hover {
    background-color: #000000;
    color: #fff;
    border: 1px solid #fff;
  }
  @media (max-width: 768px) {
    height: 50vh;
  }
  @media (max-width: 425px) {
    width: 22.5rem;
    height: 48vh;
  }
`;
const Title = styled.h2`
  font-size: calc(1em + 0.5vw);
`;

const Subtitle = styled.div`
  padding-top: 0.1rem;
  border-bottom: 2px solid #000;
  display: flex;
  flex-wrap: wrap;
  font-size: calc(0.7em + 0.3vw);
  ${Box}:hover & {
    border-bottom: 2px solid #fff;
  }
`;

const Subtitle2 = styled.div`
  font-size: calc(0.7em + 0.2vw);
`;
const Image = styled.div`
  background-image: ${(props) => `url(${props.img})`};
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

// Framer motion configuration
const Item = {
  hidden: {
    scale: 0,
  },
  show: {
    scale: 1,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
};

const Card = (props) => {
  const {
    id,
    title,
    subtitle,
    Img1,
    years,
    grade,
    school,
    Img2,
    years2,
    grade2,
    school2,
  } = props.data;

  return (
    <Box key={id} variants={Item}>
      <Title className="font-bold">{title}</Title>
      <Subtitle>
        <span className="mb-2">{subtitle}</span>
      </Subtitle>
      <div className="flex my-4 h-full ">
        <div className="grid grid-cols-2 gap-2 ">
          <Image img={Img1} />
          <Subtitle2 className="flex flex-col justify-center text-left">
            <span className="font-bold text-xl">{years}</span>
            <span className="font-bold text-lg">{grade}</span>
            <span>{school}</span>
          </Subtitle2>
          <Image img={Img2} />
          <Subtitle2 className="flex flex-col justify-center text-left">
            <span className="font-bold text-xl">{years2}</span>
            <span className="font-bold text-lg">{grade2}</span>
            <span>{school2}</span>
          </Subtitle2>
        </div>
      </div>
    </Box>
  );
};

export default Card;
